import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { SessionsFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkSessionsPOSTErrorResponse, ParkSessionsPOSTRequest, ParkSessionsPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchSessions = async (requestData: ParkSessionsPOSTRequest): Promise<ParkSessionsPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkSessionsPOSTSuccessResponse>("/sessions", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkSessionsPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: SessionsFailReason };
  }
};
